export default __webpack_public_path__ + "static/media/KyleWagner.68cf2b60.jpg";